<template>
    <div>
        <VueSlickCarousel class="content-carrousel" v-bind="slickSettings">
            <div class="content-carrousel-slide" v-for="(item, index) in items">
                <div class="inside-area">
                    <picture
                        v-if="item.image_url && item.image_url.length > 0"
                        :style="{ 'max-width': imageMaxWidth(item) }"
                    >
                        <img v-if="!lazyLoadEnabled" :src="item.image_url" class="image-area" loading="lazy" />
                        <img v-if="lazyLoadEnabled" v-lazy="item.image_url" class="image-area" loading="lazy" />
                        <div v-if="lazyLoadEnabled" class="spinner-border" role="status">
                            <span class="visually-hidden"></span>
                        </div>
                    </picture>
                    <div class="content-area" :style="{ 'max-width': imageMaxWidth(item, true) }">
                        <div class="caption" v-html="item.label"></div>
                        <a v-if="item.href !== null && item.target !== 'modal'" :href="item.href">{{ readmore }}</a>
                        <b-button
                            v-if="item.target === 'modal'"
                            v-b-modal="'carrosel-modal-' + _uid + '-' + index"
                            class="btn btn-yellow"
                            >{{ item.readMore }}</b-button
                        >
                    </div>
                </div>
            </div>
        </VueSlickCarousel>

        <div v-for="(item, index) in items">
            <b-modal
                v-if="item.target === 'modal'"
                :id="'carrosel-modal-' + _uid + '-' + index"
                size="lg"
                hide-footer
                centered
                ><div class="modal-body" v-html="item.modal"></div
            ></b-modal>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    components: { VueSlickCarousel },
    props: ["items", "settings", "readmore"],

    data: () => {
        return {
            currentFilter: "",
            lazyLoadEnabled: true,
            slickSettings: {
                dots: true,
                dotsClass: "slick-dots custom-dot-class",
                arrows: true,
                autoplay: true,
                infinite: true,
                speed: 200,
                variableWidth: true,
                adaptiveHeight: true,
                draggable: true,
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesPerRow: 1,
                        },
                    },
                ],
            },
        };
    },
    beforeMount() {
        if (this.settings["lazy_load"] !== undefined) {
            this.lazyLoadEnabled = this.settings["lazy_load"];
        }

        Object.keys(this.settings).forEach(
            function (key) {
                this.slickSettings[key] = this.settings[key];
            }.bind(this)
        );
    },
    methods: {
        imageMaxWidth: function (item, textSide) {
            if (textSide === true && item.image_width !== null) {
                return 80 - parseInt(item.image_width) + "%";
            }

            if (item.image_width !== null) {
                return item.image_width + "%";
            }
        },
    },
};
</script>
